import {AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer} from 'recharts';
import {Card} from "react-bootstrap";
import PropTypes from "prop-types";
import TooltipInfo from "../TooltipInfo.jsx";

const data = [
    {
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
]

export const StackedAreaCharts = ({data, dataKeys, title, selectors, tooltipKey}) => {

    const tooltipHtml = useSelector(state =>
        state.chartTooltips.msg[tooltipKey]?.value
    );

    return (
        <Card>
            <Card.Header>
                <div className={'d-flex justify-content-between gap-3'}>
                    <div className={'d-flex justify-content-between'}>
                        <div className={'fs-5'}>
                            {title ?? 'Analiza'}
                        </div>
                        <div>
                            {tooltipHtml && (
                                <TooltipInfo text={tooltipHtml} className="ms-2" />
                            )}
                        </div>
                    </div>
                    <div>
                        {!!selectors && selectors()}
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <ResponsiveContainer
                    width="100%" height={300}>
                    <AreaChart
                        width={500}
                        height={400}
                        data={data}
                        margin={{
                            top: 10,
                            right: 30,
                            left: 0,
                            bottom: 0,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="name"/>
                        <YAxis/>

                        <Tooltip/>
                        {/*<Area type="monotone" dataKey="amt" stackId="1" stroke="#ffc658" fill="#ffc658"/>*/}
                        {
                            dataKeys.map((dataKey, idx) => {

                                    return <Area key={idx} type="monotone" stackId="1" dataKey={dataKey.dataKey} stroke={dataKey.color}/>
                                }
                            )
                        }
                    </AreaChart>
                </ResponsiveContainer>
            </Card.Body>
        </Card>
    )

}

StackedAreaCharts.prototype

StackedAreaCharts.defaultProps = {
    data: data,
    dataKeys: [
        {dataKey: 'pv', color: '#8884d8'},
        {dataKey: 'uv', color: '#82ca9d'}
    ],
    title: 'Analiza',
    selectors: null,
    tooltipKey: PropTypes.string,

}
